import styled from "styled-components";

const FlexContainer = styled.div`
  display: flex;
`;

export default FlexContainer;
